export default "__VITE_ASSET__dMJCnULg__"